import { ROLES } from 'core/constants/roles'
import { useApiMenuGetUserPreferences } from '../api/menu/useApiMenuGetUserPreferences'

export const useUserHasRoles = (requiredRoles: ROLES[]): boolean => {
  const { data: user } = useApiMenuGetUserPreferences()
  const userRoles = user?.roles || []
  return requiredRoles.some(requiredRole => userRoles.includes(requiredRole))
}
